import path from 'path';
import { WebviewId } from '@gitlab-org/webview-plugin';
import { FastifyPluginRegistration } from '../http';
import { WEBVIEW_BASE_PATH } from './constants';

import { setupWebviewRoutes } from './routes';

type Options = {
  webviewIds: WebviewId[];
};

export const createWebviewPlugin = (options: Options): FastifyPluginRegistration => ({
  plugin: (fastify, { webviewIds }) =>
    setupWebviewRoutes(fastify, {
      webviewIds,
      getWebviewResourcePath: buildWebviewPath,
    }),
  options,
});

const buildWebviewPath = (webviewId: WebviewId) => path.join(WEBVIEW_BASE_PATH, webviewId);
